<template>
  <div class="pt-6 divide-y divide-gray-200">
    <div class="px-4 sm:px-6">
      <div>
        <h2 class="text-lg leading-6 font-medium text-gray-900">
          Profile
        </h2>
        <p class="mt-1 text-sm text-gray-500">
          It's important to also keep this information up to date for billing
          and other purposes. Some of this information (such as phone number)
          may be accessed by media clients.
        </p>
      </div>
      <div class="mt-6 grid grid-cols-12 gap-6">
        <div class="col-span-12 sm:col-span-6">
          <label for="name" class="block text-sm font-medium text-gray-700"
            >Name</label
          >
          <input
            type="text"
            id="name"
            autocomplete="given-name"
            class="mt-1 block bg-gray-50 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm cursor-not-allowed"
            :value="userInfo.name"
            disabled
          />
        </div>

        <div class="col-span-12 sm:col-span-6">
          <label for="last_name" class="block text-sm font-medium text-gray-700"
            >Email Address</label
          >
          <input
            type="email"
            id="email"
            autocomplete="email"
            class="mt-1 block bg-gray-50 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none sm:text-sm cursor-not-allowed"
            :value="userInfo.email"
            disabled
          />
        </div>

        <div class="col-span-6">
          <label for="address" class="block text-sm font-medium text-gray-700"
            >Address (Line 1)</label
          >
          <input
            type="text"
            id="address"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            v-model="userSettings.address1"
          />
        </div>
        <div class="col-span-6"></div>
        <div class="col-span-6">
          <label for="address2" class="block text-sm font-medium text-gray-700"
            >Address (Line 2)</label
          >
          <input
            type="text"
            id="address2"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            v-model="userSettings.address2"
          />
        </div>
        <div class="col-span-6"></div>

        <div class="col-span-5">
          <label for="city" class="block text-sm font-medium text-gray-700"
            >City</label
          >
          <input
            type="text"
            id="city"
            autocomplete="organization"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            v-model="userSettings.city"
          />
        </div>
        <div class="col-span-3">
          <label for="state" class="block text-sm font-medium text-gray-700"
            >State</label
          >
          <input
            type="text"
            id="state"
            autocomplete="organization"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            v-model="userSettings.state"
          />
        </div>
        <div class="col-span-2">
          <label for="zip" class="block text-sm font-medium text-gray-700"
            >Zipcode</label
          >
          <input
            type="number"
            id="zip"
            autocomplete="organization"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            v-model="userSettings.zipcode"
          />
        </div>
        <div class="col-span-2">
          <label for="zip" class="block text-sm font-medium text-gray-700"
            >Country</label
          >
          <input
            type="text"
            id="zip"
            autocomplete="organization"
            class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
            v-model="userSettings.country"
          />
        </div>
      </div>
    </div>
    <div class="mt-4 py-4 px-4 flex justify-end sm:px-6">
      <button
        type="submit"
        class="ml-5 bg-light-blue-700 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-light-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500"
        v-on:click="updateSettings"
      >
        Save
      </button>
    </div>
  </div>
</template>

<script>
import * as Config from "@/config";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Settings",
  data() {
    return {
      userSettings: {
        address1: null,
        address2: null,
        city: null,
        state: null,
        zipcode: null,
        phone: null,
        facebook: null,
        twitter: null,
        instagram: null,
        country: "US"
      },
      loading: false
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    this.getUserSettings();
  },
  methods: {
    ...mapActions(["addToastMessage"]),
    async getUserSettings() {
      const res = await this.$http.get(
        Config.apiPath + "/api/v2/stringer/account/settings"
      );
      if (res.data !== null && res.data !== "") {
        this.userSettings = res.data;
      }
    },
    async updateSettings() {
      this.loading = true;
      try {
        await this.$http.post(
          Config.apiPath + "/api/v2/stringer/account/settings",
          { settings: this.userSettings }
        );
        this.addToastMessage({
          type: "success",
          title: "Profile Updated"
        });
      } catch (e) {
        this.addToastMessage({
          type: "error",
          title: "Whoops!",
          text: "Something went wrong, try again."
        });
      }
      this.loading = false;
    }
  }
};
</script>
